export const CycleLogModificationType = {
	CycleCreated: 'CycleCreated',
	CycleUpdated: 'CycleUpdated',
} as const;

// may contain a comment
export const CycleUserMessageActionType = {
	UserCommented: 'UserCommented',
	UserAlert: 'UserAlert',
	UserRejected: 'UserRejected',
	UserApproved: 'UserApproved',
};

export const CycleLogWithUserCommentType = {
	...CycleUserMessageActionType,
	System: 'System',
} as const;

export const CycleLogDoneStatusType = {
	CycleArchived: 'CycleArchived',
	CycleFinished: 'CycleFinished',
	CycleSuccessful: 'CycleSuccessful',
} as const;

export type CycleLogDoneStatusType = (typeof CycleLogDoneStatusType)[keyof typeof CycleLogDoneStatusType];

// notifications and reminders
export const CycleLogNotificationType = {
	UserNotified: 'UserNotified',
	StationAlert: 'StationAlert',
	EmailSent: 'EmailSent',
	SmsSent: 'SmsSent',
	WhatsappSent: 'WhatsappSent',
} as const;
export type CycleLogNotificationType = (typeof CycleLogNotificationType)[keyof typeof CycleLogNotificationType];

// errors and warnings
export const CycleLogErrorType = {
	Error: 'Error',
	CycleExpired: 'CycleExpired',
	CycleFailed: 'CycleFailed',
	CycleCanceled: 'CycleCanceled',
	StationRejected: 'StationRejected',
	StationTimedout: 'StationTimedout',
} as const;
export type CycleLogErrorType = (typeof CycleLogErrorType)[keyof typeof CycleLogErrorType];

export const CycleLogActionType = {
	...CycleLogModificationType,
	...CycleLogWithUserCommentType,
	...CycleLogDoneStatusType,
	...CycleLogNotificationType,
	...CycleLogErrorType,
	CycleStarted: 'CycleStarted',
	UserTimedout: 'UserTimedout',
	StationArrived: 'StationArrived',
	UserNotified: 'UserNotified',
	StationApproved: 'StationApproved',
	StationRejected: 'StationRejected',
	StationTimedout: 'StationTimedout',
	CycleFailed: 'CycleFailed',
	CycleCanceled: 'CycleCanceled',
	TriggerActivated: 'TriggerActivated',
	CycleExpired: 'CycleExpired',
	CycleTemplatePrivate: 'CycleTemplatePrivate',
	CycleTemplatePublic: 'CycleTemplatePublic',
	UserAlert: 'UserAlert',
	SmsSent: 'SmsSent',
	WhatsappSent: 'WhatsappSent',
	CycleDraft: 'CycleDraft',
	CycleForm: 'CycleForm',
	FormFilled: 'FormFilled',
	EmailSent: 'EmailSent',
	CycleDearchived: 'CycleDearchived',
	StationAlert: 'StationAlert',
	Error: 'Error',
} as const;

export type CycleLogActionType = (typeof CycleLogActionType)[keyof typeof CycleLogActionType];
/* -------------------------------------------------------------------------------------------------------------- */
export const CycleSystemLogDescriptionType = {
	CycleDefaultTriggersShown: 'CycleDefaultTriggersShown',
} as const;

export type CycleSystemLogDescriptionType = (typeof CycleSystemLogDescriptionType)[keyof typeof CycleSystemLogDescriptionType];
